<template>
  <div class="account-container">
    <template v-if="mId">
      <MyHeader>
        <div class="btn-con" slot="nav-left">
          <router-link to="/setting.html" class="header-btn"><img src="~@/assets/img/setting.png"
              class="setting-icon" /></router-link>
        </div>
        <div class="btn-con" slot="nav-right">
          <router-link to="/customer-service.html" class="header-btn"><img src="~@/assets/img/service.png"
              class="service-icon" /></router-link>
        </div>
      </MyHeader>
      <div class="account-content">
        <div class="information-box">
          <div class="my-data">
            <div class="head img-box">
              <img :src="userData.headPicUrl" alt="" class="img" />
            </div>
            <div class="username-box">
              <h3 class="username">{{userData.nickName}}</h3>
              <p class="id-con" ref="code-con">ID {{mId}}<a class="copy-btn" href="javascript:;"
                  @click.stop="execCopy(mId)">复制</a></p>
            </div>
          </div>
          <div class="able-like">
            <p class="like-num">喜欢×{{userData.likeBalance}}</p>
            <a href="javascript:;" class="purchase-btn" @click="purchase">购买</a>
          </div>
        </div>
        <div class="status-box">
          <router-link to="/like.html" class="status-item">
            <span class="status-icon"></span>
            <span class="status-info">我喜欢的 {{userData.likeCount}}</span>
          </router-link>
          <a href="javascript:;" @click="toLikeMeList" class="status-item">
            <span class="status-icon"></span>
            <span class="status-info">喜欢我的 {{userData.belikedCount}}</span>
          </a>
          <router-link to="/follow.html" class="status-item">
            <span class="status-icon"></span>
            <span class="status-info">关注的 {{userData.followCount}}</span>
          </router-link>
          <router-link to="/ask.html" class="status-item">
            <span class="status-icon"></span>
            <span class="status-info">索要微信 {{userData.getwechatCount}}</span>
          </router-link>
        </div>
      </div>
      <dl class="information-content base-information">
        <dt class="information-title">
          <span class="title">基础资料</span>
          <p class="introduce">完善资料后，可在平台展示个人信息；且赠送1个喜欢名额（7天有效）</p>
        </dt>
        <dd class="information-item" @click="toBaseInfo">
          <p class="item-type">
            <img src="~@/assets/img/icon/1.png" alt="" class="icon2" />
            <span class="type-name">完善基础资料</span>
          </p>
          <p class="item-status" :class="transferBaseStatus(userData).class">
            <span class="status-name">{{transferBaseStatus(userData).text}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </dd>
      </dl>
      <dl class="information-content certificate-information">
        <dt class="information-title">
          <span class="title">证件审核</span>
          <p class="introduce">全部认证完成后每天赠送1个喜欢名额（当天有效）；且额外再赠送1个喜欢名额（7天有效）</p>
        </dt>
        <dd class="information-item" @click="jumpTo('id')">
          <p class="item-type cert">
            <img src="~@/assets/img/icon/2.png" alt="" class="icon2" />
            <span class="type-name">身份认证</span>
          </p>
          <p class="item-status" :class="transferStatus(userData.identityAuth).class">
            <span class="status-name">{{transferStatus(userData.identityAuth).text}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </dd>
        <dd class="information-item" @click="jumpTo('education')">
          <p class="item-type education">
            <img src="~@/assets/img/icon/3.png" alt="" class="icon2" />
            <span class="type-name">学历认证</span>
          </p>
          <p class="item-status" :class="transferStatus(userData.academicAuth).class">
            <span class="status-name">{{transferStatus(userData.academicAuth).text}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </dd>
        <dd class="information-item" @click="jumpTo('career')">
          <p class="item-type work">
            <img src="~@/assets/img/icon/4.png" alt="" class="icon2" />
            <span class="type-name">工作认证</span>
          </p>
          <p class="item-status" :class="transferStatus(userData.workAuth).class">
            <span class="status-name">{{transferStatus(userData.workAuth).text}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </dd>
      </dl>

      <div class="information-content condition">
        <div class="information-title">
          <div>
            <span class="title">择偶标准</span>
            <p class="introduce">选择标准后，首页精准展示</p>
          </div>
          <span class="edit-btn" @click="switchConditionPop"><img src="~@/assets/img/edit.png"
              class="edit-icon" /></span>
        </div>
        <div class="condition-content">
          <p class="condition-item">
            <span class="condition-type">年龄</span>
            <span
              class="condition-value">{{userData.selectionAgeMin || userData.selectionAgeMax ? `${userData.selectionAgeMin ? userData.selectionAgeMin : '不限'}-${userData.selectionAgeMax ? userData.selectionAgeMax : '不限'}岁` : '不限'}}</span>
          </p>
          <p class="condition-item">
            <span class="condition-type">身高</span>
            <span
              class="condition-value">{{userData.selectionHighMin || userData.selectionHighMax ? `${userData.selectionHighMin ? userData.selectionHighMin : '不限'}-${userData.selectionHighMax ? userData.selectionHighMax : '不限'}cm` : '不限'}}</span>
          </p>
          <p class="condition-item">
            <span class="condition-type">学历</span>
            <span
              class="condition-value">{{userData.selectionAcadmic ? educationMap[userData.selectionAcadmic] : '不限'}}</span>
          </p>
          <p class="condition-item">
            <span class="condition-type">地区</span>
            <span
              class="condition-value">{{userData.selectionCityId ? parseInt(userData.selectionCityId) === 900000 ? `${userData.selectCountry} ${userData.selectState}` : areaData['city_list'][userData.selectionCityId] : '不限'}}</span>
          </p>
          <p class="condition-item">
            <span class="condition-type">感情状态</span>
            <span
              class="condition-value">{{userData.selectionSingleStatus != null ? statusMap[userData.selectionSingleStatus] : '不限'}}</span>
          </p>
        </div>
      </div>

      <div class="rules">
        <h3 class="rule-title">真诚、严肃、平等交友 </h3>
        <p class="rule">1、本平台的信息资料皆来源于用户本身，平台只是做信息的展示和功能的实现，用户需对自己提供的资料真实性负全部责任，如有虚假信息欺诈行为，本平台有权追责。</p>
        <p class="rule">
          2、用户上传证件资料（如身份证、营业执照、工作证、劳动合同等）委托本平台做实名审核，审核通过后则成为平台的实名用户。本平台只做资料核对和形式上的审查，真实度有限，仅可作为实名参考，并不承担任何担保。</p>
        <p class="rule">3、 请大家在使用本平台交友过程中保护好自己， 对自身的人身和财产安全负全部责任， 做好安全防范措施，避免财产往来和过密接触。因此而产生的的纠纷违法等行为，平台本身不负责任何法律责任。</p>
        <p class="rule">4、如遇到虚假信息、欺骗行为、不良目的或人品素质等有问题的用户，欢迎向本平台投诉并举证。平台将视具体情况做出相应的处理（如限制该用户权限、账号封禁、全平台公告等方式），以保障他人的权益和安全。
        </p>
      </div>

      <ICP class="account-ICP"></ICP>

      <van-popup v-model="showConditionPop" position="right">
        <div class="edit-condition">
          <MyHeader title="择偶标准" :back="switchConditionPop" />
          <div class="edit-condition-content">
            <p class="sub-title">请告诉我们你心目中的ta</p>

            <div class="sort-item">
              <span class="sort-name">年龄(岁)</span>
              <div class="sort-input">
                <!-- <input v-model="filterData.selectionAgeMin" type="tel" class="input" name="selectionAgeMin"/> -->
                <span class="input"
                  @click.stop="triggerFilterPicker(1)">{{filterData.selectionAgeMin ? filterData.selectionAgeMin : '不限'}}</span>
                <span class="separator">至</span>
                <span class="input"
                  @click.stop="triggerFilterPicker(2)">{{filterData.selectionAgeMax ? filterData.selectionAgeMax : '不限'}}</span>
                <!-- <input v-model="filterData.selectionAgeMax" type="tel" class="input" name="selectionAgeMax"/> -->
              </div>
            </div>

            <div class="sort-item">
              <span class="sort-name">身高(cm)</span>
              <div class="sort-input">
                <span class="input"
                  @click.stop="triggerFilterPicker(3)">{{filterData.selectionHighMin ? filterData.selectionHighMin : '不限'}}</span>
                <span class="separator">至</span>
                <span class="input"
                  @click.stop="triggerFilterPicker(4)">{{filterData.selectionHighMax ? filterData.selectionHighMax : '不限'}}</span>
              </div>
            </div>

            <div class="sort-item">
              <span class="sort-name">学历</span>
              <div class="sort-input sort-select" @click="showEduPicker = true">
                <span class="value">{{educationMap[filterData.selectionAcadmic]}}</span>
                <a href="javascript:;" class="enter-btn">
                  <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
                </a>
              </div>
            </div>

            <div class="sort-item area-item">
              <span class="sort-name">地区</span>
              <div class="area-con">
                <div class="sort-input sort-select" @click.stop="switchAreaPicker">
                  <span class="value">{{filterData.selectionCityId === '900000' ? '海外' : areaData['city_list'][filterData.selectionCityId]}}</span>
                  <a href="javascript:;" class="enter-btn">
                    <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
                  </a>
                </div>
                <div class="foreign-input sort-select" v-if="filterData.selectionCityId === '900000'">
                  <input type="text" placeholder="海外国家名" class="input" v-model="filterData.selectCountry" />
                  <input type="text" placeholder="海外地区名" class="input" v-model="filterData.selectState" />
                </div>
              </div>
            </div>

            <div class="sort-item">
              <span class="sort-name">感情状态</span>
              <div class="sort-input sort-select" @click="showStatusPicker = true">
                <span class="value">{{statusMap[filterData.selectionSingleStatus]}}</span>
                <a href="javascript:;" class="enter-btn">
                  <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
                </a>
              </div>
            </div>
          </div>
          <div class="btns">
            <a href="javascript:;" class="reset-btn" @click="resetCondition">清空筛选条件</a>
            <a href="javascript:;" class="ensure-btn" @click="uploadCondition">确定</a>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="showEduPicker" position="bottom">
        <van-picker show-toolbar :visible-item-count="3" :columns="EduColumns" @cancel="showEduPicker = false"
          @confirm="onConfirmEdu" />
      </van-popup>

      <van-popup v-model="showStatusPicker" position="bottom">
        <van-picker show-toolbar :visible-item-count="3" :columns="statusColumns" @cancel="showStatusPicker = false"
          @confirm="onConfirmStatus" />
      </van-popup>

      <van-popup v-model="isShowAreaPicker" position="bottom">
        <van-area :area-list="areaData" :columns-num="areaColumns"
          :columns-placeholder="['请选择']"
          :value="userData.selectionCityId ? userData.selectionCityId.toString() : '100100'" :show-toolbar="true"
          @change="handleAreachange" @confirm="handleAreaconfirm" @cancel="handleAreacancel"></van-area>
      </van-popup>

      <van-popup v-model="showFilterPicker" position="bottom">
        <van-picker show-toolbar :visible-item-count="3" :default-index="filterDefaultIndex" :columns="filterColumns"
          @cancel="showFilterPicker = false" @confirm="onConfirmFilter" />
      </van-popup>

      <purchaseModal :show="isShowModal" @close="isShowModal=false" @callback="isShowModal=false" />

      <AccelerateAduit v-model="isShowAcceDialog" @confirm="isShowAcceDialog = false"
        @close="isShowAcceDialog = false" />

      <van-dialog v-model="showAuthDialog" :message="authDialogMessage" :confirmButtonText="authButtonText"
        @confirm="jump"></van-dialog>

      <van-dialog v-model="isShowWebchat" confirmButtonText="知道了" @confirm="toLikeMeList">
        <div class="follow-webchat-dialog">
          <p class="tip">关注服务小助手，“喜欢”消息不遗漏</p>
          <img class="code" src="/static/img/wechat-public.jpeg" alt="">
        </div>
      </van-dialog>

      <baseNoticeModal :show="isShowBaseModal" @close="isShowBaseModal=false" @confirm="comfirmBaseModal" />

    </template>

    <Login v-else />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import MyHeader from '@/components/common/myHeader'
import Login from '@/components/common/login'
import purchaseModal from '@/components/common/purchaseModal'
import AccelerateAduit from '@/components/dialog/accelerateAduit'
import baseNoticeModal from '@/components/common/baseNoticeModal'
import ICP from '@/components/common/ICP.vue'
import { copy } from '@/utils/tools'
import Storage from '@/utils/Storage'
import { Toast } from 'vant'
import wxApi from '@/utils/wxAuth'

export default {
  name: 'account',
  components: {
    MyHeader,
    Login,
    purchaseModal,
    AccelerateAduit,
    ICP,
    baseNoticeModal
  },
  data () {
    return {
      isShowModal: false,
      isShowAcceDialog: false,
      isShowBaseModal: false,
      showConditionPop: false,
      showEduPicker: false,
      // 婚恋状态数据
      showStatusPicker: false,
      areaColumns: 2,
      isShowAreaPicker: false,
      // 择偶信息
      showFilterPicker: false,
      filterType: 1,
      filterData: {
        selectionAgeMin: '',
        selectionAgeMax: '',
        selectionHighMin: '',
        selectionHighMax: '',
        selectionAcadmic: 0,
        selectionCityId: '',
        selectCountry: '',
        selectState: ''
      },
      showAuthDialog: false,
      authDialogMessage: '',
      authButtonText: '知道了',
      path: '',
      isShowWebchat: false
    }
  },
  computed: {
    ...mapState({
      userData: 'userData',
      educationMap: 'educationMap',
      statusMap: 'statusMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      userId: 'userId',
      mId: 'mId'
    }),
    isEditableCert () {
      // 只有基础资料审核通过才能上传证件
      let flag = false
      if (this.userData.firstBaseAuth || parseInt(this.userData.basedataAuth) === 1) {
        flag = true
      }
      return flag
    },
    EduColumns () {
      let arr = []
      let map = Object.assign({}, this.educationMap)
      // 去掉大专以下
      delete map[9]
      delete map[8]
      for (let i in map) {
        let text = map[i]
        if (text !== '不限') {
          text = text + '及以上'
        }
        arr.push({
          value: i,
          text
        })
      }
      return arr
    },
    statusColumns () {
      let arr = []
      for (let i in this.statusMap) {
        arr.push({
          value: i,
          text: this.statusMap[i]
        })
      }
      // 删除最后两项单身状态
      return arr.slice(0, -2)
    },
    filterColumns () {
      let arr = []
      switch (this.filterType) {
        case 1:
        case 2:
          arr = Array.from(Array(66), (v, k) => k + 15)
          arr.unshift('不限')
          break
        case 3:
        case 4:
          arr = Array.from(Array(81), (v, k) => k + 120)
          arr.unshift('不限')
          break
      }
      return arr
    },
    filterDefaultIndex () {
      let index = 0
      switch (this.filterType) {
        case 1:
          index = this.filterColumns.indexOf(this.filterData.selectionAgeMin)
          break
        case 2:
          index = this.filterColumns.indexOf(this.filterData.selectionAgeMax)
          break
        case 3:
          index = this.filterColumns.indexOf(this.filterData.selectionHighMin)
          break
        case 4:
          index = this.filterColumns.indexOf(this.filterData.selectionHighMax)
          break
      }
      index = index >= 0 ? index : 0
      return index
    }
  },
  watch: {
    userData (val) {
      if (this.userId && val.status === 0) {
        return this.$router.push('/setUserData/sex.html')
      }
      if (this.userId) {
        let filterData = this.filterData
        let userData = this.userData
        filterData.selectionAgeMin = userData.selectionAgeMin
        filterData.selectionAgeMax = userData.selectionAgeMax
        filterData.selectionAcadmic = userData.selectionAcadmic
        filterData.selectionCityId = '' + userData.selectionCityId
        filterData.selectCountry = '' + userData.selectCountry
        filterData.selectState = '' + userData.selectState
        filterData.selectionHighMax = userData.selectionHighMax
        filterData.selectionHighMin = userData.selectionHighMin
        filterData.selectionSingleStatus = userData.selectionSingleStatus
        if (userData.selectionCityId === 90000) {
          this.areaColumns = 1
        } else {
          this.areaColumns = 2
        }
        let d = this.userData
        if (this.$route.name === 'Account' && parseInt(d.basedataAuth) === 3) {
          wxApi.configShare({
            title: 'Hello单身部落',
            // desc: 'ID号-学历-工作-年龄-城市',
            desc: `${this.mId}-${this.educationMap[d.education]}-${d.ifStudent ? '在读' : d.job}-${d.age}-${parseInt(d.cityId) === 900000 ? (d.country + ' ' + d.state) : this.areaData['city_list'][d.cityId]}`,
            link: `${location.origin}/info-${this.mId}.html`,
            imgUrl: `${d.headPicUrl}`
          })
        }
      }
    }
  },
  activated () {
    if (this.userId) {
      this.$root.openLoading()
      this.fetchUserData().then(() => {
        this.$root.closeLoading()
      }).catch(() => {
        this.$root.closeLoading()
      })
    }
  },
  methods: {
    ...mapActions({
      fetchUserData: 'fetchUserData'
    }),
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),
    transferBaseStatus (d) {
      let base = parseInt(d.basedataAuth)
      if (d.firstBaseAuth) {
        let c = {
          class: 'emphasize',
          text: '已审核通过'
        }
        switch (base)  {
          case 1:
            c.class = 'emphasize'
            c.text = '修改的资料待审核'
            break
          case 2:
            c.class = 'emphasize'
            c.text = '修改的资料审核不通过'
            break
        }
        return c
      } else {
        return this.transferStatus(base)
      }
    },
    transferStatus (status) {
      let c = {}
      switch (parseInt(status)) {
        case 0:
        case 4:
          c.class = 'static'
          c.text = '待提交'
          break
        case 1:
          c.class = 'emphasize'
          c.text = '待审核'
          break
        case 2:
          c.class = 'emphasize'
          c.text = '审核不通过'
          break
        case 3:
          c.class = 'emphasize'
          c.text = '已审核通过'
          break
      }
      return c
    },
    execCopy (text) {
      copy(text, this.$refs['code-con']).then(res => {
        this.$toast('复制成功')
      }, () => {
        this.$toast('复制失败')
      })
    },
    checkStatus () {
      // 权限判断
      const base = parseInt(this.userData.basedataAuth)
      console.log()
      if (!this.userData.firstBaseAuth && base !== 3) {
        if (base === 0) {
          this.errorStatus = 1
          this.authDialogMessage = '您当前未通过个人资料审核，请先通过个人资料审核'
          this.authButtonText = '完善资料'
          this.path = '/baseInfo.html'
          this.showAuthDialog = true
        } else if (base === 1) {
          this.isShowAcceDialog = true
        } else if (base === 2) {
          this.errorStatus = 1
          this.authDialogMessage = '资料未通过审核，请修改重新提交'
          this.authButtonText = '修改资料'
          this.path = '/baseInfo.html'
          this.showAuthDialog = true
        }
        return
      }
      return true
    },
    purchase () {
      this.isShowModal = true
    },
    toBaseInfo () {
      if (this.userData.firstBaseAuth) {
        this.$router.push('/displayInfo.html')
      } else {
        this.$router.push('/baseInfo.html')
      }
    },
    toLikeMeList () {
      if (Storage.load('hadPopWebChat')) {
        // 更新缓存时间
        Storage.save('hadPopWebChat', true)
        this.isShowWebchat = false
        this.$nextTick(() => {
          this.$router.push({
            path: '/likeme.html'
          })
        })
      } else {
        Storage.save('hadPopWebChat', true)
        this.isShowWebchat = true
      }
    },
    switchConditionPop (e) {
      if (!this.checkStatus()) return
      e && e.preventDefault()
      this.showConditionPop = !this.showConditionPop
    },
    onConfirmEdu (val) {
      this.filterData.selectionAcadmic = val.value
      this.showEduPicker = false
    },
    onConfirmStatus (val) {
      this.filterData.selectionSingleStatus = val.value
      this.showStatusPicker = false
    },
    triggerFilterPicker (type) {
      this.filterType = type
      this.showFilterPicker = true
    },
    onConfirmFilter (val) {
      this.showFilterPicker = false
      let value = val === '不限' ? 0 : val
      switch (this.filterType) {
        case 1:
          this.filterData.selectionAgeMin = value
          break
        case 2:
          this.filterData.selectionAgeMax = value
          break
        case 3:
          this.filterData.selectionHighMin = value
          break
        case 4:
          this.filterData.selectionHighMax = value
          break
      }
    },
    resetCondition () {
      this.filterData = {
        selectionAgeMin: 0,
        selectionAgeMax: 0,
        selectionHighMin: 0,
        selectionHighMax: 0,
        selectionAcadmic: 0,
        selectionCityId: 100100,
        selectCountry: '',
        selectState: '',
        selectionSingleStatus: 0
      }
    },
    uploadCondition () {
      if (this.filterData.selectionAgeMin !== 0 && this.filterData.selectionAgeMax !== 0 && this.filterData.selectionAgeMin > this.filterData.selectionAgeMax) {
        this.$toast('年龄范围有误')
        return
      }
      if (this.filterData.selectionHighMin !== 0 && this.filterData.selectionHighMax !== 0 && this.filterData.selectionHighMin > this.filterData.selectionHighMax) {
        this.$toast('身高范围有误')
        return
      }
      this.$root.openLoading()
      this.$http('/api/member/updateSelectionStandard', {
        ...this.filterData
      }).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000') {
          this.updateUserData(this.filterData)
        } else {
          Toast(res.msg)
        }
      }).catch(err => {
        this.$toast(err)
        this.$root.closeLoading()
      })
      this.switchConditionPop()
    },
    jumpTo (type) {
      if (this.isEditableCert) {
        switch (type) {
          case 'id':
            this.authDialogMessage = this.userData.firstIdentityAuth ? '' : '平台认证你的证件信息仅用于身份认证，不作为其他用途'
            this.path = '/upload-cert.html'
            break
          case 'education':
            this.authDialogMessage = this.userData.firstAcademicAuth ? '' : '平台认证你的证件信息仅用于学历认证，不作为其他用途'
            this.path = '/upload-education.html'
            break
          case 'career':
            this.authDialogMessage = this.userData.firstWorkAuth ? '' : '平台认证你的证件信息仅用于工作认证，不作为其他用途'
            this.path = '/upload-career.html'
            break
        }
      } else {
        this.checkStatus()
        return
      }
      if (this.authDialogMessage) {
        this.showAuthDialog = true
      } else {
        this.jump()
      }
    },
    jump () {
      this.showAuthDialog = false
      this.$nextTick(() => {
        this.$router.push(this.path)
      })
    },
    switchAreaPicker () {
      this.isShowAreaPicker = !this.isShowAreaPicker
    },
    handleAreacancel () {
      this.isShowAreaPicker = false
    },
    handleAreachange (picker, res) {
      if (res[0].code === '900000') {
        this.areaColumns = 1
      } else {
        this.areaColumns = 2
      }
    },
    handleAreaconfirm (res) {
      this.isShowAreaPicker = false
      if (!res[0].code) {
        return
      }
      // 海外地区特殊处理
      if (res[0].code === '900000') {
        this.filterData.selectionCityId = res[0].code
      } else {
        this.filterData.selectionCityId = res[1].code
      }
    },
    comfirmBaseModal () {
      this.isShowBaseModal = false
      this.$nextTick(() => this.$router.push('/baseInfo.html'))
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'SetPhone' && vm.userData.ifMobileVerify) {
        vm.isShowBaseModal = true
      } else {
        vm.isShowBaseModal = false
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    wxApi.configShare()
    next()
  }
}
</script>

<style lang="scss" scope>
@import "@/assets/scss/constant.scss";
.account-container {
  min-height: 100%;
  .header {
    .setting-icon {
      width: 34px;
    }
    .service-icon {
      width: 36px;
    }
  }
  .head {
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    width: 115px;
    height: 115px;
    border-radius: 100%;
    overflow: hidden;
  }

  .account-content {
    padding: 35px 40px;
    box-shadow: 0px 1px 2px 0px $mainColor;
    border-radius: 0px 0px 32px 32px;
    .information-box {
      display: flex;
      justify-content: space-between;
    }
    .head-box {
      margin-right: 20px;
      width: 115px;
      height: 115px;
      border-radius: 100%;
      overflow: hidden;
    }
    .username-box {
      display: inline-block;
      vertical-align: middle;
    }
    .username {
      font-size: 42px;
      line-height: 60px;
    }
    .copy-btn {
      margin-left: 20px;
      color: #9b9b9b;
      font-size: 24px;
    }

    .able-like {
      flex: 0 0 160px;
      text-align: center;
    }
    .like-num {
      margin-bottom: 10px;
      font-size: 24px;
      line-height: 34px;
    }
    .purchase-btn {
      display: block;
      padding: 14px 50px;
      color: #fff;
      font-size: 24px;
      line-height: 34px;
      background: linear-gradient(133deg, #ffb7e0 0%, $mainColor 100%);
      box-shadow: 0px 1px 2px 0px $mainColor;
      border-radius: 4px;
    }
  }
  .status-box {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    .status-item {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .status-icon {
      margin-bottom: 4px;
      flex: 0 0 50px;
      width: 50px;
      height: 50px;
      background: url("~@/assets/img/person1.png") no-repeat;
      background-size: contain;
    }
    .status-item:nth-child(2) {
      .status-icon {
        background: url("~@/assets/img/person2.png") no-repeat;
        background-size: contain;
      }
    }
    .status-item:nth-child(3) {
      .status-icon {
        background: url("~@/assets/img/person3.png") no-repeat;
        background-size: contain;
      }
    }
    .status-item:nth-child(4) {
      .status-icon {
        background: url("~@/assets/img/person4.png") no-repeat;
        background-size: contain;
      }
    }
    .status-info {
      color: #9b9b9b;
      font-size: 24px;
      line-height: 34px;
    }
  }

  .information-content {
    margin-top: 40px;
    padding: 0 40px;
  }
  .information-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 28px 22px 28px 16px;
    background: #fafbff;
  }
  .information-title {
    .title {
      font-weight: bold;
    }
    .introduce {
      color: #9b9b9b;
      margin: 8px 0;
    }
  }
  .condition {
    .information-title {
      display: flex;
      justify-content: space-between;
    }
  }
  .item-type {
    .type-name {
      font-size: 24px;
      line-height: 34px;
    }
    .icon2 {
      display: inline-block;
      vertical-align: middle;
      width: 43px;
      height: auto;
      margin-right: 15px;
    }
  }
  .item-status {
    .status-name {
      color: #9b9b9b;
      font-size: 24px;
      line-height: 34px;
    }
    .icon {
      display: inline-block;
      vertical-align: middle;
      width: 15px;
      margin-left: 32px;
    }
    &.emphasize {
      .status-name {
        color: $mainColor;
      }
    }
  }
  .condition {
    .edit-btn {
      float: right;
    }
    .edit-icon {
      display: block;
      width: 32px;
    }
  }
  .condition-item {
    display: inline-block;
    vertical-align: middle;
    margin-top: 20px;
    margin-right: 20px;
    min-width: 240px;
    border-radius: 44px;
    overflow: hidden;
  }
  .condition-type {
    display: inline-block;
    padding: 0 12px;
    min-width: 86px;
    line-height: 44px;
    text-align: center;
    background: #ffedf5;
  }
  .condition-value {
    display: inline-block;
    width: 154px;
    line-height: 44px;
    text-indent: 10px;
    background: #fafbff;
  }

  // 规则
  .rules {
    margin-top: 130px;
    padding: 0 40px;
    line-height: 40px;
  }
  .rule-title {
    text-align: center;
  }
  .rule {
    margin-top: 50px;
    color: #bfbfbf;
  }

  // 编辑择偶条件
  .edit-condition {
    width: $clientWidth;
    height: 100vh;
    .edit-condition-content {
      padding: 28px 40px;
      text-align: center;
    }
    .sub-title {
      margin-bottom: 80px;
      color: $mainColor;
      font-size: 32px;
      line-height: 44px;
    }
    .sort-item,
    .sort-input {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
    }
    .sort-item {
      margin-bottom: 40px;
    }
    .area-item {
      align-items: flex-start;
      .sort-name {
        padding-top: 20px;
      }
    }
    .area-con {
      flex: 1 1 auto;
      .foreign-input {
        display: flex;
      }
      .input {
        flex: 1 1 50%;
        border: none;
      }
    }
    .sort-input {
      flex: 1 1 auto;
      justify-content: space-between;
    }
    .sort-name {
      flex: 0 0 170px;
      font-size: 32px;
      line-height: 44px;
      text-align: left;
    }
    .input {
      flex: 0 1 180px;
      width: 180px;
      height: 80px;
      padding: 16px;
      color: #9b9b9b;
      font-size: 32px;
      line-height: 44px;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #9b9b9b;
    }
    .separator {
      color: #9b9b9b;
      font-size: 32px;
      line-height: 44px;
    }
    .sort-select {
      justify-content: flex-end;
      padding: 20px 0;
      border-bottom: 1px solid #dcdcdc;
    }
    .value {
      color: #9b9b9b;
      font-size: 32px;
      line-height: 44px;
    }
    .enter-btn {
      margin-left: 20px;
      padding: 7px 14px;
    }
    .enter {
      display: block;
      width: 14px;
    }
    .btns {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      width: 670px;
      text-align: center;
    }
    .reset-btn {
      display: inline-block;
      margin: 0 auto 40px;
      color: $mainColor;
      font-size: 32px;
      line-height: 44px;
    }
    .ensure-btn {
      display: block;
      padding: 25px;
      color: #fff;
      font-size: 36px;
      line-height: 50px;
      border-radius: 100px;
      background: linear-gradient(
        305deg,
        rgba(255, 62, 144, 1) 0%,
        rgba(255, 187, 216, 1) 100%
      );
    }
  }
  .follow-webchat-dialog {
    text-align: center;
    .tip {
      padding-top: 24px;
    }
    .code {
      display: block;
      width: 80%;
      margin: 0 auto;
    }
  }
}
</style>
